<div class="connect-state">

  <!-- Checking. Shown instead of briefly flashing "not connected" at someone who is connected. -->
  <ng-container *ngIf="state === 'unknown'">
    <mat-spinner diameter="28"></mat-spinner>
    <p class="connect-state__lead">Checking your Outlook connection…</p>
  </ng-container>

  <ng-container *ngIf="state === 'disconnected'">
    <mat-icon class="connect-state__icon">mail_outline</mat-icon>
    <p class="connect-state__lead">
      Connect your Microsoft 365 account to see your mail, calendar and contacts here.
    </p>
    <button mat-flat-button color="primary" class="connect-state__action"
            [disabled]="busy" (click)="connect.emit()">
      <mat-icon *ngIf="!busy">login</mat-icon>
      <mat-spinner *ngIf="busy" diameter="18"></mat-spinner>
      <span>{{ busy ? 'Connecting…' : 'Connect Outlook' }}</span>
    </button>
    <p class="connect-state__note">
      BizCombo gets read-only access. It can't send, delete or change anything in your mailbox.
    </p>
  </ng-container>

  <ng-container *ngIf="state === 'error'">
    <mat-icon class="connect-state__icon connect-state__icon--warn">error_outline</mat-icon>
    <p class="connect-state__lead">{{ message || 'Something went wrong talking to Outlook.' }}</p>
    <div class="connect-state__actions">
      <button mat-stroked-button (click)="retry.emit()">
        <mat-icon>refresh</mat-icon>
        <span>Try again</span>
      </button>
      <button mat-button class="connect-state__secondary" (click)="signOut.emit()">
        Sign out and reconnect
      </button>
    </div>
  </ng-container>

</div>
